// 生产构建把本文件打成普通脚本,在所有模块脚本之前执行(见 tools/cli/src/vite/prelude.ts)。
// Rolldown 拆 chunk 后不保证模块顶层代码按 import 顺序执行,读 `environment` 等全局的
// 模块可能先于 bootstrap 运行;这里先把全局与 polyfill 就位。主 bundle 仍会 import 同样的
// bootstrap,setupGlobal 与 core-js polyfill 重复执行是空操作。
import './env';
import './polyfill/browser';
